import AppToolbar from '@/app-theme/components/app/AppToolbar.vue'
import AppFooter from '@/app-theme/components/app/AppFooter.vue'
import ConfirmDialog from '@/app-theme/components/common/ConfirmDialog.vue'
import StoreCatalogToolbar from '@/app-theme/components/store/StoreCatalogToolbar.vue'
import LoginDialog from '@/app-theme/components/login/LoginDialog.vue'
import RegisterDialog from '@/app-theme/components/login/RegisterDialog.vue'
import CartDrawer from '@/app-theme/views/cart/CartDrawer.vue'
import {floatNumber} from '@/app-core/lib/helpers'
import CartCommon from '@/app-core/mixins/cart/cartCommon'
import ResetPasswordDialog from '@/app-theme/components/login/ResetPasswordDialog.vue'
import SelectTableDialog from '@/app-theme/components/common/SelectTableDialog.vue'
import TagCatalogToolbar from '@/app-theme/components/tag/TagCatalogToolbar.vue'
import CookiesConsentMixin from '@/app-theme/components/common/cookies/CookiesConsentMixin.js'

export default {
  name      : 'DefaultLayout',
  components: {
    TagCatalogToolbar,
    StoreCatalogToolbar,
    SelectTableDialog,
    ResetPasswordDialog,
    CartDrawer,
    RegisterDialog,
    LoginDialog,
    ConfirmDialog,
    AppToolbar,
    AppFooter
  },
  mixins   : [CartCommon, CookiesConsentMixin],
  dataStore: {
    AppCart   : 'App.Cart',
    AppQrItems: 'App.QrItems',
    AppType   : 'App.Type',
    StoreInfo : 'Store.Info'
  },
  data: function () {
    return {
      loginDialogVisible        : false,
      registerDialogVisible     : false,
      resetPasswordDialogVisible: false,
      selectTableDialogVisible  : false,
      navigationDrawerVisible   : false,
      fullScreenLoader          : false,
      registerInitData          : null
    }
  },
  computed: {
    showBottomNavigation() {
      const excludedRoutes = ['CheckoutDetails', 'CheckoutSuccess']
      return this.cartProductsCount && this.$vuetify.breakpoint.xsOnly && !excludedRoutes.includes(this.$route.name)
    },

    showStoreToolbar() {
      return this.$route.name === 'Store'
    },

    showTagToolbar() {
      return this.$route.name === 'Tag'
    },

    storeHeaderImageHeight() {
      switch (this.$vuetify.breakpoint.name) {
      case 'xs':
        return 225
      case 'sm':
        return 250
      case 'md':
        return 300
      case 'lg':
        return 350
      case 'xl':
        return 400
      default:
        return 400
      }
    }
  },
  watch: {},
  created() {
    this.$bus.$on('login:show-dialog', this.showLoginDialog)
    this.$bus.$on('register:show-dialog', this.showRegisterDialog)
    this.$bus.$on('reset-password:show-dialog', this.showResetPasswordDialog)
    this.$bus.$on('cart:show-dialog', this.showCartDialog)
    this.$bus.$on('select-table:show-dialog', this.showSelectTableDialog)
    this.$bus.$on('app:fullscreen-loader', this.showFullScreenLoader)
    this.$bus.$on('app:show-notification', this.onShowAppSnackbar)

    const excludedRoutes = ['OrderStatus', 'CheckoutSuccess', 'VivaPaymentSuccess', 'CheckoutFailure', 'VivaPaymentFailure', 'MarketplaceAccountConnected', 'VivaMarketplaceAccountConnected']
    if (this.AppType.isQRScanApp && !this.AppQrData && this.AppConfig.Marketplace.SelectQrDataRequired && this.AppConfig.Marketplace.SelectQrDataPopup && !excludedRoutes.includes(this.$route.name)) {
      this.$bus.$emit('select-table:show-dialog')
    }
  },
  mounted() {
    this.$root.$confirm = this.$refs.confirm
  },
  updated() {
  },
  beforeDestroy() {
    this.$bus.$off('login:show-dialog', this.showLoginDialog)
    this.$bus.$off('register:show-dialog', this.showRegisterDialog)
    this.$bus.$off('reset-password:show-dialog', this.showResetPasswordDialog)
    this.$bus.$on('cart:show-dialog', this.showCartDialog)
    this.$bus.$off('select-table:show-dialog', this.showSelectTableDialog)
    this.$bus.$off('app:fullscreen-loader', this.showFullScreenLoader)
    this.$bus.$off('app:show-notification', this.onShowAppSnackbar)
  },
  methods: {
    floatNumber,
    showLoginDialog(visible = true) {
      this.loginDialogVisible = !!visible
      this.registerDialogVisible = false
    },

    showRegisterDialog(data, visible = true) {
      this.registerInitData = data || null
      this.registerDialogVisible = !!visible
      this.loginDialogVisible = false
    },

    showResetPasswordDialog(visible = true) {
      this.resetPasswordDialogVisible = !!visible
      this.registerDialogVisible = false
      this.loginDialogVisible = false
    },

    showCartDialog(visible = true) {
      this.navigationDrawerVisible = !!visible
    },

    showSelectTableDialog() {
      this.selectTableDialogVisible = true
    },

    showFullScreenLoader(visible = true) {
      this.fullScreenLoader = !!visible
    },

    onShowAppSnackbar(data) {
      this.$snotify[data.type](data.body, data.title, {
        timeout        : data.hasOwnProperty('timeout') ? data.timeout : 3000,
        showProgressBar: data.hasOwnProperty('showProgressBar') ? data.showProgressBar : true,
        closeOnClick   : data.hasOwnProperty('closeOnClick') ? data.closeOnClick : true,
        pauseOnHover   : data.hasOwnProperty('pauseOnHover') ? data.pauseOnHover : true,
        position       : data.position ? data.position : 'centerTop',
        buttons        : data.buttons ? data.buttons : [],
        icon           : data.icon ? data.icon : null,
        img            : data.img ? data.img : null
      })
    }
  }
}
